import { PlacesType, Tooltip as ReactTooltip } from 'react-tooltip'
import { generateUniqueID } from 'web-vitals/dist/modules/lib/generateUniqueID';
import styles from "./Tooltip.module.scss";

interface TooltipProps {
    place: PlacesType
    content: string
}

export const Tooltip = ({content, place = 'top'}: TooltipProps) => {
    const uniqueId = generateUniqueID()

    return (
        <>
            <img src="/assets/info-icon.svg" alt="info" className={styles.textRight} data-tooltip-id={uniqueId}/>
            <ReactTooltip style={{maxWidth: "350px", fontSize: "16px", zIndex: 999}} id={uniqueId} place={place} className={"tooltip"} content={content} ></ReactTooltip>
        </>
    )
}
